import { LOCALSTORAGE_AUTH, LOCALSTORAGE_AUTH2 } from '../common/constants';

export interface IAuthConfig {
    oauth2: {
        accessToken: string;
        accessTokenExpiration: string;
    };
    information: {
        webApiEndPoint: string;
        webApiVersion: string;
        customerName: string;
    };
    /**
     * FRO-11551: true when this session was opened with the master password AND
     * the user chose full (master) rights. Iframe apps forward it as the
     * X-Master-User request header; the WebAPI re-validates it against the
     * token's password type (ReadRequestInfoMiddleware), so this is a hint,
     * never client-side authorization.
     */
    IsMasterUser: boolean;
}

const EMPTY_AUTH_CONFIG: IAuthConfig = {
    oauth2: {
        accessToken: '',
        accessTokenExpiration: '',
    },
    information: {
        webApiEndPoint: '',
        webApiVersion: '',
        customerName: '',
    },
    IsMasterUser: false,
};

/**
 * Reads the stored session for the embedded-app broker and substatus-helper.
 */
export const getAuthConfig = (): IAuthConfig => {
    try {
        const authInfo = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH2) || '{}');
        // `auth.apiVersion` is what axios.defaults.baseURL was built from (including the
        // WA-3578 upgrade override); AuthorizationData can be stale there.
        const apiVersion = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH) || '{}')?.apiVersion;

        return {
            oauth2: {
                accessToken: authInfo?.data?.oauth2?.accessToken || '',
                accessTokenExpiration: authInfo?.data?.oauth2?.accessTokenExpiration || '',
            },
            information: {
                webApiEndPoint: authInfo?.data?.information?.webApiEndPoint || '',
                webApiVersion: apiVersion || authInfo?.data?.information?.webApiVersion || '',
                customerName: authInfo?.data?.information?.customerName || '',
            },
            // Root keys of the same AuthorizationData object, written by
            // LocalStorageAuthorizationData.updateAuthorization during the
            // master-login confirmation (user-actions.store.ts).
            IsMasterUser: authInfo?.loggedWithMasterPassword === true && authInfo?.loggedAsMaster === true,
        };
    } catch (error) {
        console.error('Error parsing authConfig:', error);
        return EMPTY_AUTH_CONFIG;
    }
};
